<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:80px;"></div>
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span class="notice-back" @click="goList">{{$t('notice.title')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{ detail.title }}</span>
						</div>
						<div class="notice-detail">
							<h3 class="notice-detail__title">{{ detail.title }}</h3>
							<div class="notice-detail__time">{{ detail.created_at }}</div>
							<div class="notice-detail__content" v-html="detail.content" @click="onContentClick"></div>
							<div class="notice-detail__actions" v-if="showVerifyEntry">
								<el-button type="primary" @click="goVerify">{{ $t('notice.goVerify') }}</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import notice_detail from './notice_detail_controller';
	export default notice_detail;
</script>

<style src="@/assets/css/my/setting.css" scoped></style>
<style src="@/assets/css/my/notice.css" scoped></style>
